import { createHttpClient, HttpClient } from '@wix/http-client';

export async function open(testEndpoint: string, url: string) {
  await createHttpClient()
    .post(testEndpoint, undefined, {
      params: {
        url,
      },
    })
    .catch((error: unknown) => {
      if (HttpClient.isHttpError(error) && error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }

      throw error;
    });
}
